import { CSVApi } from '@bpm-web-app/stream-api-sdk';
import { supremeConfig } from '../config';

export class Csv {
    static client = new CSVApi(supremeConfig);

    static csvUpload = (file?: Blob) => Csv.client.importCsv(file);
}
